// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"modal-title-module--titleWrapper--FHYfi","titleIcon":"modal-title-module--titleIcon--2tVhe"};